import React from "react";
import { Grid, TextField } from "@mui/material";
import RolesMultiSelect from "./RolesMultiSelect";

const TrainingModuleForm = ({ module, setModule, errors, roles, setRoles }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setModule((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSelect = (value) => {
    setModule((prev) => ({
      ...prev,
      training_roles: value?.map((item) => ({ id: Number(item?.value) })),
    }));
    setRoles(value);
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid xs={4} item>
          <TextField
            required
            fullWidth
            value={module?.sequenceId}
            name="sequenceId"
            label="Sequence Number"
            variant="outlined"
            error={errors?.sequenceId}
            helperText={errors?.sequenceId}
            onChange={handleChange}
            InputLabelProps={{
              shrink: module?.sequenceId,
            }}
          />
        </Grid>
        <Grid xs={8} item>
          <TextField
            required
            fullWidth
            value={module?.title}
            name="title"
            label="Title"
            variant="outlined"
            error={errors?.title}
            helperText={errors?.title}
            onChange={handleChange}
            InputLabelProps={{
              shrink: module?.title,
            }}
          />
        </Grid>
        <Grid xs={12} item>
          <TextField
            fullWidth
            value={module?.description}
            multiline
            rows={2}
            name="description"
            label="Description"
            variant="outlined"
            onChange={handleChange}
            sx={{ height: "auto", "& .MuiInputBase-root": { height: "auto" } }}
            InputLabelProps={{
              shrink: module?.description,
            }}
          />
        </Grid>
        <Grid xs={12} item>
          <RolesMultiSelect
            roles={roles}
            handleSelect={handleSelect}
            errors={errors}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default TrainingModuleForm;
